import React, { useState } from 'react';
import AceEditor from 'react-ace';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'ace-builds/src-noconflict/mode-sql';
import 'ace-builds/src-noconflict/mode-text';
import 'ace-builds/src-noconflict/theme-chrome';
import PropagateLoader from "react-spinners/PropagateLoader";
import { Box } from '@mui/material';
import moment from 'moment-timezone';
import './sqltutorial.css';

function SqlDateTool() {
  const [query, setQuery] = useState('');
  const [explanation, setExplanation] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedZone, setSelectedZone] = useState('UTC');

  const timezones = [
    'UTC', 'GMT', 'EST', 'EDT', 'CST', 'CDT', 'MST', 'MDT', 'PST', 'PDT', 
    'IST', 'CET', 'CEST', 'AEST', 'AEDT', 'JST', 'KST', 'HKT', 'SGT', 'EET', 
    'EEST', 'AST', 'AKST', 'HST', 'Timezone Naive'
  ];

  const sqldate = async () => {
    try {
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      setExplanation('');

      // Get the local timestamp without the Z
      let localTimestamp = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss.SSS');

      const response = await axios.post('https://us-central1-explo-website-tools.cloudfunctions.net/dateSQLquery', { date: localTimestamp, query, timezone: selectedZone });
      setExplanation(response.data.explanation);
      setIsLoading(false);
    } catch (error) {
      console.error('Error explaining SQL:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="app-container">
      <h1>{`SQL Date and Time Formatter`}</h1>
      <div className="query-input">
        <textarea
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{ width: '100%', minHeight: '50px', maxHeight: '150px', fontSize: '14px' }}
          placeholder="Enter the database you're working with here"
        />
      <div className="input-row">
        <DatePicker
          selected={selectedDate}
          onChange={date => setSelectedDate(date)}
          timeInputLabel='Time:'
          showTimeInput
          dateFormat="MM/dd/yyyy h:mm aa"
          className="date-picker"
        />
        <div>
          <label htmlFor="timezone-select">Select Timezone: </label>
          <select
            id="timezone-select"
            value={selectedZone}
            onChange={(e) => setSelectedZone(e.target.value)}
            className="timezone-select"
          >
            {timezones.map((zone, index) => (
              <option key={index} value={zone}>{zone}</option>
            ))}
          </select>
        </div>
        <button onClick={sqldate} className="explain-button">Convert date to formatted SQL</button>
      </div>
      {isLoading && 
          <Box style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
            <PropagateLoader color="#3C66DD" />
          </Box>
        }
      </div>
      {/* <h2>{moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}</h2>
      <h2>{selectedZone}</h2> */}
      {explanation && (
        <div className="explanation-output">
          <h2>Explanation</h2>
          <AceEditor
            mode="text"
            theme="github"
            name="explanationEditor"
            value={explanation}
            wrapEnabled={true}
            fontSize={14}
            readOnly={true}
            showPrintMargin={false}
            showGutter={true}
            highlightActiveLine={false}
            setOptions={{
              showLineNumbers: false,
              tabSize: 2,
            }}
            style={{ width: '100%', minHeight: '50px', maxHeight: '150px' }}
          />
        </div>
      )}
    </div>
  );
}

export default SqlDateTool;
